import { createContext, useContext } from 'react';

import type { HeaderLevel } from '@coursera-web/cds-labs';

type HeaderLevelContextType = {
  currentLevel: HeaderLevel;
  nextLevel: HeaderLevel;
};

export const HeaderLevelContext = createContext<HeaderLevelContextType>({
  currentLevel: 'h2',
  nextLevel: 'h3',
});

/**
 * @description This hook is used to get the current and next header level for page config components in the learner home page
 */
export const useHeaderLevel = () => {
  return useContext(HeaderLevelContext);
};
